import React, { useEffect, useState, useRef } from "react";
import { connect } from "react-redux";
import { getpettycashSearchResult } from "../../actions/accounting/pettycash";
import Rendertable from "./Rendertable";
import { Skeleton, Button } from 'antd';
import Excelldownload from "./TemplateDownload";
import { useHistory } from "react-router-dom";

const ContactList = ({
  getpettycashSearchResult,
  List,
  updatelist,
  setUpdatelist,
  Auth,
}) => {
  const [loading, setLoading] = useState(false);
  const [data, setData] = useState([]);
  const pageno = useRef(1);
  const history = useHistory();
  const page_size = useRef(20);
  useEffect(() => {
    setLoading(true);
    if (Auth.superuser) {
      getpettycashSearchResult("", "", "", "", pageno.current, page_size.current).then((result) => {
        setData(result);
        setLoading(false);
      });
    } else {
      getpettycashSearchResult("", Auth.profile.branch.id, "", "", pageno.current, page_size.current).then((result) => {
        setData(result);
        setLoading(false);
      });
    }
  }, [updatelist]);

  if (loading) {
    return <Skeleton active />;
  }else {
  return (
    <>
      <Excelldownload data={data} />
      
          
          <Button
            style={{ marginLeft: "10px" }}
            onClick={() => history.push("/import-petty-cash")}
            type="primary"
          >
            Petty cash import!
          </Button>
        
      {
        <Rendertable
          List={data}
          updatelist={updatelist}
          setUpdatelist={setUpdatelist}
          pageno={pageno} 
          page_size={page_size}
        />
      }
    </>
  );
}
};

const mapStateToProps = (state) => {
  return {
    List: state.contacts.contactlistsearchresult,

    Auth: state.auth,
  };
};

export default connect(mapStateToProps, {
  getpettycashSearchResult,
})(ContactList);
